import { render, staticRenderFns } from "./GrcDialog2.vue?vue&type=template&id=e527e4f2&"
import script from "./GrcDialog2.vue?vue&type=script&lang=js&"
export * from "./GrcDialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports